import { watch } from './mediaQueryHelper';
import { PeopleBanner } from './components/PeopleBanner';
import { ProjectsFilter } from './components/ProjectsFilter';
import { ScrollWindow } from './components/ScrollWindow';
// import { Xmas2020PeopleBanner } from './components/Xmas2020PeopleBanner';
// import { Xmas2023 } from './components/Xmas2023';
import { EmployeeSearch } from './components/EmployeeSearch';
import $ from 'jquery';

import './components/KeyboardNavigationClass';

import './polyfills';

// Attached to window so they can be referenced by inline code in the templates.
(window as any).PeopleBanner = PeopleBanner;
(window as any).ProjectsFilter = ProjectsFilter;
(window as any).ScrollWindow = ScrollWindow;
// (window as any).Xmas2020PeopleBanner = Xmas2020PeopleBanner;
// (window as any).Xmas2023 = Xmas2023;
(window as any).EmployeeSearch = EmployeeSearch;
(window as any).MediaQueryHelper = { watch };

(window as any).$ = $;
(window as any).jQuery = $;

/**
 * Document ready function
 */
(window as any).ready = (fn: (arg?: any) => void, arg: any = null) => {
  if (document.readyState !== 'loading') {
    fn(arg);
  } else {
    document.addEventListener('DOMContentLoaded', () => fn(arg));
  }
};
